var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRustore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rustore_logo_intro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rustore_logo_intro",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.240002,88 C22.327902,88 12.371802,88 6.18591202,81.8140939 C-7.10542736e-15,75.6281939 -7.10542736e-15,65.6719939 -7.10542736e-15,45.7597939 L-7.10542736e-15,42.2397939 C-7.10542736e-15,22.3275939 -7.10542736e-15,12.3714939 6.18590202,6.18555392 C12.371802,0 22.327902,0 42.239902,0 L42.240002,0 L45.760002,0 L45.760002,0 C65.672102,0 75.628202,0 81.814102,6.18554392 C88,12.3713939 88,22.3275939 88,42.2397939 L88,45.7597939 C88,65.6719939 88,75.6281939 81.814102,81.8140939 C75.628202,88 65.672102,88 45.760002,88 L42.240002,88 Z",
    id: "Path",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.886902,54.2310939 C48.516002,53.6387939 46.853502,51.5178939 46.853502,49.0853939 L46.853502,20.4274939 C46.853502,17.6645939 49.464302,15.6382939 52.157302,16.3109939 L69.211302,20.5711939 C71.582302,21.1633939 73.244802,23.2842939 73.244802,25.7167939 L73.244802,54.3746939 C73.244802,57.1375939 70.634002,59.1639939 67.941002,58.4912939 L50.886902,54.2310939 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.789302,67.4268939 C16.418302,66.8345939 14.755902,64.7136939 14.755902,62.2811939 L14.755902,33.6232939 C14.755902,30.8603939 17.366602,28.8340939 20.059602,29.5067939 L37.113702,33.7669939 C39.484602,34.3591939 41.147102,36.4800939 41.147102,38.9125939 L41.147102,67.5704939 C41.147102,70.3333939 38.536302,72.3597939 35.843302,71.6869939 L18.789302,67.4268939 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.838102,60.8291939 C32.467102,60.2368939 30.804702,58.1159939 30.804702,55.6834939 L30.804702,27.0256939 C30.804702,24.2627939 33.415502,22.2363939 36.108502,22.9090939 L53.162502,27.1692939 C55.533502,27.7615939 57.195902,29.8824939 57.195902,32.3149939 L57.195902,60.9727939 C57.195902,63.7357939 54.585202,65.7620939 51.892102,65.0893939 L34.838102,60.8291939 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.999902,63.6249939 L45.999902,63.6249939 C45.253102,63.4347939 44.721602,62.7743939 44.695502,62.0041939 L43.953602,40.1182939 C43.739002,37.2216939 41.588802,34.9179939 39.341902,34.2395939 C39.215702,34.2014939 39.081002,34.2527939 39.006302,34.3612939 L39.006302,34.3612939 C38.930402,34.4715939 38.959702,34.6242939 39.065602,34.7062939 C39.620502,35.1357939 41.147602,36.5374939 41.147602,38.9550939 L41.143102,62.3941939 L45.999902,63.6249939 Z",
    id: "Path",
    fill: "#2B71F6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.052802,57.0207939 L62.052802,57.0207939 C61.306602,56.8340939 60.774402,56.1756939 60.748402,55.4068939 L60.006302,33.5225939 C59.791702,30.6259939 57.641602,28.3222939 55.394602,27.6438939 C55.268502,27.6057939 55.133802,27.6570939 55.059102,27.7655939 L55.059102,27.7655939 C54.983102,27.8758939 55.012502,28.0285939 55.118402,28.1105939 C55.673202,28.5400939 57.200402,29.9417939 57.200402,32.3593939 L57.195902,55.8064939 L62.052802,57.0207939 Z",
    id: "Path",
    fill: "#2B71F6",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRustore);
export default __webpack_public_path__ + "static/media/rustore.7f7611b48a98dd6f8dd918e43f28b3a0.svg";
export { ForwardRef as ReactComponent };